interface GpaBadgeProps {
  gpa: number | null | undefined
  size?: 'sm' | 'md' | 'lg'
}

function gpaStyle(gpa: number): { color: string; bg: string } {
  if (gpa >= 3.5) return { color: '#059669', bg: 'rgba(16,185,129,0.1)' }
  if (gpa >= 2.5) return { color: '#10B981', bg: 'rgba(52,211,153,0.1)' }
  if (gpa >= 1.5) return { color: '#D97706', bg: 'rgba(245,158,11,0.1)' }
  return { color: '#DC2626', bg: 'rgba(239,68,68,0.1)' }
}

const sizeClasses: Record<NonNullable<GpaBadgeProps['size']>, string> = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
  lg: 'text-base px-3 py-1.5',
}

export function GpaBadge({ gpa, size = 'md' }: GpaBadgeProps) {
  if (gpa == null) {
    return (
      <span
        className={`inline-flex items-center rounded-lg font-medium ${sizeClasses[size]}`}
        style={{ color: '#94A3B8', background: 'rgba(148,163,184,0.1)', fontFamily: 'var(--font-family-mono)' }}
      >
        — GPA
      </span>
    )
  }
  const { color, bg } = gpaStyle(gpa)
  return (
    <span
      className={`inline-flex items-center rounded-lg font-semibold ${sizeClasses[size]}`}
      style={{ color, background: bg, fontFamily: 'var(--font-family-mono)' }}
    >
      {gpa.toFixed(2)} GPA
    </span>
  )
}

/** Standalone hero-sized GPA number, not a badge */
export function GpaHero({ gpa }: { gpa: number | null | undefined }) {
  const color = gpa == null
    ? '#94A3B8'
    : gpa >= 3.5 ? '#059669'
    : gpa >= 2.5 ? '#10B981'
    : gpa >= 1.5 ? '#D97706'
    : '#DC2626'

  return (
    <div>
      <div style={{ fontFamily: 'var(--font-family-mono)', fontSize: '2rem', fontWeight: 600, lineHeight: 1, color }}>
        {gpa != null ? gpa.toFixed(2) : '—'}
      </div>
      <div style={{ fontSize: 11, color: '#94A3B8', fontWeight: 500, marginTop: 3 }}>Avg GPA</div>
    </div>
  )
}
